<template>
  <header class="row font-weight-bold bg-gray">
    <div class="col-9 py-1 pr-0" v-html="name" />
    <div class="col-3 pr-0">
      <a role="button"
        v-on:click="onClickPDF(name, serial)"
        v-bind:href="'/downloads/' + pdf"
        target="_blank"
        class="btn btn-sm btn-black float-right"
      >{{ buttonPDF }}</a>
      <span class="p-1 pr-md-3 d-inline-block float-right">{{ serial }}</span>
    </div>
  </header>
</template>

<script>

import { getString } from '../../../language'

export default {
  name: 'StoCscResultItemHeader',
  props: {
    name: String,
    serial: String,
    pdf: String
  },
  data: function () {
    return {
      buttonPDF: getString('result.buttonPDF')
    }
  },
  methods: {
    onClickPDF: function (name, serial) {
      this.$gtm.trackEvent({
        event: 'clickElement',
        category: 'pdf',
        action: 'download',
        label: name + ' : ' + serial,
        value: null
      })
    }
  }
}

</script>
